module.exports = __webpack_public_path__ + "img/logo.566b5f5d.svg";